import { GuidToUserIdPage } from '@repo/ccc-main-app-lib/src/pages/GuidToUserIdPage/GuidToUserIdPage.tsx'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/user-guid/$guid')({
  component: UserGuidToUserIdPageLayoutRoute,
})

function UserGuidToUserIdPageLayoutRoute() {
  const { guid } = Route.useParams()

  return <GuidToUserIdPage guid={guid} />
}
